import React, { useState, useEffect } from 'react';
import { deleteUser } from '@aws-amplify/auth';
import { useHistory } from 'react-router-dom';

import {
  Form, notification, Button, Modal,
} from 'antd';
// import { brandingConfig } from '../../../../config';

import { deleteSeagullUser } from '../../../../services/user.service';

const DeleteAccount = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deletedUserData, setDeletedUserData] = useState({});

  const history = useHistory();

  const deleteAccount = async () => {
    try {
      console.log('Account Delete Attempt Stage 1');
      // TODO: API call to delete details
      setDeletedUserData(await deleteSeagullUser());
    } catch (err) {
      notification.error({
        description: err,
      });
      console.log(err);
    } finally {
      setIsModalOpen(false);
    }
    setIsModalOpen(false);
  };

  useEffect(() => {
    try {
      console.log('Account Delete Attempt Stage 2');
      console.log(deletedUserData);
      // TODO: API call to delete details
      if (deletedUserData && deletedUserData?.deleted_at) {
        console.log('Account Delete Attempt Stage 3');
        deleteUser();
        history.push('/');
      }
    } catch (err) {
      notification.error({
        description: err,
      });
      console.log(err);
    }
  }, [deletedUserData]);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    console.log('Delete Attempt Aborted');
    setIsModalOpen(false);
  };

  return (
    <Form layout="vertical">
      <div className="h3" style={{ color: '#770000', marginBottom: 15 }}>Destructive Action</div>
      <Button
        onClick={() => showModal()}
        shape="round"
        style={{
          background: '#FF0000',
          color: '#FFFFFF',
          border: 0,
        }}
      >
        Delete Account
      </Button>
      <Modal
        title="Delete Your Seagull Account"
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={isModalOpen}
        onOk={deleteAccount}
        okText="Yes, please"
        okButtonProps={{ danger: true }}
        onCancel={handleCancel}
        cancelText="Oops, nope"
        cancelButtonProps={{ default: true }}
      >
        <p>
          Are you sure you want to delete your Seagull account?
          Once deleted, your account and all personal information
          stored with Seagull will be permanently removed.
        </p>
      </Modal>
    </Form>
  );
};

export default DeleteAccount;

DeleteAccount.propTypes = {};

DeleteAccount.defaultProps = {};
